import axios from 'axios'
import { HOST_URL, VERSION_API } from '@/utils/constantes';

const api = axios.create({
  baseURL: `${HOST_URL}/${VERSION_API}`
})

api.interceptors.request.use((config: any) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  response => response,
  error => {
    if (!error.response) {
      // Sin respuesta del servidor (conexión fallida)
      console.error('❌ Error de red: No se pudo conectar con el servidor');
    } else if (error.response.status === 401) {
      // Token expirado u otros errores de autorización
      console.warn('⚠️ Token no autorizado o expirado');
      // Puedes redirigir o cerrar sesión automáticamente aquí
    } else {
      console.error(`❌ Error ${error.response.status}:`, error.response.data);
    }

    // Siempre rechaza el error para que las acciones Vuex lo capturen también
    return Promise.reject(error);
  }
)

export default api